module.exports={select:"Seç",selected:"Seçili"};